import filters from '@/components/filter/index.vue'
import eTable from '@/components/table/index.vue'
import utils from '@/utils'
import { defineComponent, ref, reactive } from 'vue'
import { mapState, mapGetters } from 'vuex'
import minix from './minix'
import buyData from '@/components/buyData/index.vue'
import market from '@/components/market/index.vue'
import { robustNormalize } from "./utils"
import axios from "axios"

const { isLoginStatus, randomTimer } = utils

export default defineComponent({
  mixins: [minix],
  components: {
    'e-table': eTable,
    filters,
    'buy-data': buyData,
    market
  },
  props: {
    // 是否显示选择
    canSelect: {
      type: Boolean,
      default: true
    },
    /*
      multiFactor 默认所有因子表
      multiFactor_v1_1 多因子1.1
      fiveFactor 五因子表
      dbLow  双低表
      power 强势表
    */
    type: {
      type: String,
      default: 'multiFactor'
    },
    height: {
      type: [String, Number],
      default: '0'
    },
    // 只展示自选的
    isOnlyCollect: {
      type: Boolean,
      default: false
    },
    // 是否显示头部筛选
    hiddenFilter: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      isExtend: ref(false),  // 是否拓展表格
      hiddenRedeem: true,  // 隐藏强赎
      autoBuyData: JSON.parse(localStorage.getItem('autoBuyData')) || false,  // 自动购买数据
      autoRefresh: false,  // 自动刷新
      autoRefreshTimer: null,  // 自动刷新计时器
      searchText: ref(''), // 搜索文本
      // data: reactive([]), // 表格数据
      rawData: [], // 原始数据
      allData: reactive([]),  // 所有表格数据备份
      // result: [], // 备份数据
      levels: reactive({  // 转债等级
        '全部': 0,
        'B-': 1,
        'B': 2,
        'B+': 3,
        'BB-': 4,
        'BB': 5,
        'BB+': 6,
        'BBB-': 7,
        'BBB': 8,
        'BBB+': 9,
        'A-': 10,
        'A': 11,
        'A+': 12,
        'AA-': 13,
        'AA': 14,
        'AA+': 15,
        'AAA': 16
      }),
      maxScrollTop: ref(0),  // 最大滚动高度
      page: ref(1),  // 页码
      size: ref(30), // 单页大小
      timer: ref(null), // 定时器
      filterParams: {}, // 过滤的参数
      collectList: [], // 收藏列表
      
      // 申请数据
      buyData: {
        visible: false,
      },

      // 实时行情
      marketDialog: {
        visible: false,
        bondCode: '',
        code: '',
        title: ''
      },


      // 自定义因子数据
      customFactorData: reactive({
        visible: false,
        id: 0,
        name: "未命名",
        data: [
          {
            label: "转债余额",
            prop: "转债余额",
            weight: 0,
            reverse: 1
          },
          {
            label: "ATR",
            prop: "ATR", // 直接用，返回的是未归一的
            weight: 0,
            reverse: 0
          },
          {
            label: "波动率",
            prop: "VIX11",
            weight: 0,
            reverse: 0
          },
          {
            label: "转债价格",
            prop: "转债价格",
            weight: 0,
            reverse: 1
          },
          {
            label: "转债涨跌幅",
            prop: "转债涨跌幅",
            weight: 0,
            reverse: 1
          },
          {
            label: "正股涨跌幅",
            prop: "正股涨跌幅",
            weight: 0,
            reverse: 1
          },
          {
            label: "转股溢价率",
            prop: "转股溢价率",
            weight: 0,
            reverse: 1
          },
          {
            label: "价值溢价",
            prop: "价值溢价",
            weight: 0,
            reverse: 1
          },
          {
            label: "转债与正股涨跌幅差",
            prop: "zzzfc1", // 这个值就是zfc1 _score未归一化的数据
            weight: 0,
            reverse: 1
          },
        ],
      }),
      // 常用策略
      strategies: reactive([
        // {
        //   id:9,
        //   name: "紫阳强势",
        //   data: [
        //     {
        //       "label": "转债余额",
        //       "prop": "转债余额",
        //       "weight": 0.5,
        //       "reverse": 1
        //     },
        //     {
        //       "label": "ATR",
        //       "prop": "ATR",
        //       "weight": 0,
        //       "reverse": 0
        //     },
        //     {
        //       "label": "波动率",
        //       "prop": "VIX11",
        //       "weight": 2,
        //       "reverse": 0
        //     },
        //     {
        //       "label": "转债价格",
        //       "prop": "转债价格",
        //       "weight": 0.27,
        //       "reverse": 1
        //     },
        //     {
        //       "label": "转债涨跌幅",
        //       "prop": "转债涨跌幅",
        //       "weight": 0,
        //       "reverse": 1
        //     },
        //     {
        //       "label": "正股涨跌幅",
        //       "prop": "正股涨跌幅",
        //       "weight": 0,
        //       "reverse": 1
        //     },
        //     {
        //       "label": "转股溢价率",
        //       "prop": "转股溢价率",
        //       "weight": 5.62,
        //       "reverse": 1
        //     },
        //     {
        //       "label": "价值溢价",
        //       "prop": "价值溢价",
        //       "weight": 0.62,
        //       "reverse": 1
        //     },
        //     {
        //       "label": "转债与正股涨跌幅差",
        //       "prop": "zzzfc1",
        //       "weight": 1,
        //       "reverse": 1
        //     }
        //   ]
        // }
      ]),
      // 当前选中数据
      selectedStrategy: ref(""),
      isAdding: ref(false),
      strategieName: ref(""),
      // 右键菜单
      contextMenu: reactive({
        visible: false,
        x: 0,
        y: 0,
        row: null
      })
    }
  },
  computed: {
    ...mapState({
      bondList: state => state.bondList,
      allPlates: state => state.allPlates
    }),
    ...mapGetters([
      'isValidity'
    ]),

    // 搜索转债
    data(){
      let ind=0
      return this.allData.filter(row=>{
        ind++
        // 隐藏强赎【收藏模式无需隐藏】
        if (!this.isOnlyCollect && this.hiddenRedeem && (row['强赎状态'])) {
          ind--
          return false 
        }
        // 仅显示收藏时
        const collectItem=this.collectList.find(i=>i.bond_code==row['转债代码'])
        if (collectItem) {
          // 给列表加上自选价格、自选涨跌幅
          row.bond_price=collectItem.bond_price
          // row.bond_change=collectItem.bond_change
          row.bond_change=(((row['转债价格'] / collectItem.bond_price) - 1) * 100).toFixed(2)
        }
        if (this.isOnlyCollect && !collectItem) return false

        if (Object.keys(this.filterParams).length) {
          let { priceMin, priceMax, 转债余额, volume, 转股溢价率, 评级, 正股涨跌幅Min, 正股涨跌幅Max, KMin, KMax, sort, MA20乖离, 涨幅对标, 所属版块, 剩余期限, 强赎修正, 转债涨跌幅Min, 转债涨跌幅Max } = this.filterParams
          MA20乖离=parseFloat(MA20乖离) / 100

          // 排序 
          if (sort && ind>sort) return false

          // 价格筛选
          if (priceMin && parseFloat(row['转债价格']) < parseFloat(priceMin)) return false
          if (priceMax && parseFloat(row['转债价格']) > parseFloat(priceMax)) return false

          // 转债涨跌幅筛选
          if (转债涨跌幅Min && parseFloat(row['转债涨跌幅']) < parseFloat(转债涨跌幅Min)) return false
          if (转债涨跌幅Max && parseFloat(row['转债涨跌幅']) > parseFloat(转债涨跌幅Max)) return false

          // k值筛选
          if (KMin && parseFloat(row['K']) < parseFloat(KMin)) return false
          if (KMax && parseFloat(row['K']) > parseFloat(KMax)) return false

          // 剩余规模
          if (转债余额 && parseFloat(row['转债余额']) > parseFloat(转债余额)) return false

          // 成交量
          if (volume && parseFloat(row['volume']) < parseFloat(volume)) return false
          
          // 正股涨跌幅
          if (正股涨跌幅Min && parseFloat(row['正股涨跌幅']) < parseFloat(正股涨跌幅Min)) return false
          if (正股涨跌幅Max && parseFloat(row['正股涨跌幅']) > parseFloat(正股涨跌幅Max)) return false
          
          if (MA20乖离 && parseFloat(row['MA20乖离']) < parseFloat(MA20乖离)) return false

          // 溢价率
          if (转股溢价率 && parseFloat(row['转股溢价率'])*100 > parseFloat(转股溢价率)) return false
          if (涨幅对标 && parseFloat(row['涨幅对标']) > parseFloat(涨幅对标)) return false

          // 剩余期限
          if (剩余期限 && parseFloat(row['剩余期限']) < parseFloat(剩余期限)) return false
          
          // 强赎修正
          if (强赎修正 && parseFloat(row['强赎修正']) > parseFloat(强赎修正)) return false

          // 评级
          if (评级 && row['评级'] != 评级) return false

          // 所属版块
          // console.log(所属版块)
          if (所属版块 && 所属版块.length && 所属版块.every(it=>!row['所属版块'] || !row['所属版块'].includes(it))) return false
        }

        // 搜索
        if (this.searchText) {
          return row['转债代码'].includes(this.searchText) || row['债券简称'].includes(this.searchText) || row['正股名称'].includes(this.searchText)
        }
        return true
      })
      .map(row=>({
        ...row,
        isCollect: this.collectList.find(it=>it['bond_code']==row['转债代码'])
      }))
      .slice(0, this.page * this.size)
    },
    // 筛选参数
    filterConfig() {
      return [
        {
          label: '转债价格',
          field: 'price',
          type: 'range',
          unit: '元'
        },
        {
          label: '转债涨跌幅',
          field: '转债涨跌幅',
          type: 'range',
          unit: '%'
        },
        {
          label: '剩余规模≤',
          field: '转债余额',
          type: 'input',
          unit: '亿元'
        },
        {
          label: '正股涨跌幅',
          field: '正股涨跌幅',
          type: 'range',
          unit: '%'
        },
        {
          label: '剩余期限≥',
          field: '剩余期限',
          type: 'input',
          unit: '年'
        },
        {
          label: '强赎修正≤',
          field: '强赎修正',
          type: 'input',
          unit: '天'
        },
        {
          label: '溢价率≤',
          field: '转股溢价率',
          type: 'input',
          unit: '%'
        },
        {
          label: '排名≤',
          field: 'sort',
          type: 'input',
          unit: ''
        },
        {
          label: 'MA20乖离≥',
          field: 'MA20乖离',
          type: 'input',
          unit: '%'
        },
        {
          label: '涨幅对标≤',
          field: '涨幅对标',
          type: 'input',
          unit: '%'
        },
        {
          label: '评级',
          field: '评级',
          type: 'select',
          unit: '',
          list: [
            {
              label: '全部',
              value: '',
            },
            {
              label: 'AAA',
              value: 'AAA',
            },
            {
              label: 'AA+',
              value: 'AA+',
            },
            {
              label: 'AA',
              value: 'AA',
            },
            {
              label: 'AA-',
              value: 'AA-',
            },
            {
              label: 'A+',
              value: 'A+',
            },
            {
              label: 'A',
              value: 'A',
            },
            {
              label: 'A-',
              value: 'A-',
            },
            {
              label: 'BBB',
              value: 'BBB',
            },
            {
              label: 'BBB-',
              value: 'BBB-',
            },
            {
              label: 'BB',
              value: 'BB',
            },
          ]
        },
        {
          label: '所属版块',
          field: '所属版块',
          type: 'select',
          multiple: true,
          unit: '',
          list: this.allPlates,
          style: 'width: 360px'
        }
      ]
    },
    // 热门板块
    hotPlates(){
      return this.getHotPlates({
        allData: JSON.parse(JSON.stringify(this.rawData)),
        allPlates: this.allPlates && this.allPlates.map(r=>r.label) || []
      })
    },

    headerBtns(){
      let arr=[
        {
          size: 'small',
          text: '简化/拓展',
          onclick:()=>{
            this.isExtend = !this.isExtend
          }
        },
        {
          size: 'small',
          text: '刷新',
          onclick:()=>{
            this.getData()
          }
        },
        {
          size: 'small',
          text: '申请数据',
          onclick:()=>{
            this.buyData.visible=true
          }
        },
        {
          size: 'small',
          text: '150积分下载数据',
          onclick:()=>{
            if (!utils.isLoginStatus()) return this.$message.error('请先登录')
            this.downloadFile()
          }
        },
      ]
      // 自定义不给下载数据了
      if (this.type=='diyTable') {
        arr.pop()
        arr.push({
          size: 'small',
          type: "primary",
          text: '因子设置',
          onclick:()=>{
            // 这里可以做保存操作，比如存 localStorage 或请求接口
            if (this.allData[0]["综合分数"]=='申请数据可见'){
              this.$message.error('申请数据后可看')
              return 
            }

            // this.getStrategieList()
            this.customFactorData.visible = true
          }
        })
      }
      return arr
    },
  },
  methods: {
    // 获取计出数据
    async getData(params={}){
      let res = await this.$api.getBasedata({
        ...params,
        // ...(()=>{
        //   // 收藏时候去掉提醒
        //   if (this.isOnlyCollect) return {
        //     noMessage: {
        //       noSuccess: 1,
        //       noFail: 1
        //     }
        //   }
        //   return {}
        // })()
      })
      if (res) {
        // console.log(res)
        // this.data=res.data.slice(0, 30)
        this.handleData(res)
        !params.noBuy && this.autoBuyDataFn(this.autoBuyData)

        // 计算自定义
        await this.getStrategieList()
        if (this.$route.path=="/diy_table" && this.allData.length && this.allData[0]["综合分数"]!='申请数据可见') {
          this.doDiyScore()
        }
      }
    },
    // 处理数据
    handleData(res){
      this.allData=res.data && res.data.length && res.data.reduce((res, cur)=>{
        if (!res.find(i=>i['转债代码']==cur['转债代码'])) res.push(cur)
        return res 
      }, []) || this.allData
      // this.allData=res.data && res.data.length && res.data || this.allData
      const fn={
        multiFactor:()=>{
          this.allData.sort((a, b)=>{
            return b['综合分数'] - a['综合分数']
          })
        },
        'multiFactor_v1_1': ()=>{
          this.allData.sort((a, b)=>{
            return b['多因子V1.1'] - a['多因子V1.1']
          })
        },
        fiveFactor: ()=>{
          this.allData.sort((a, b)=>{
            return b['稳健分数'] - a['稳健分数']
          })
        },
        dbLow: ()=>{
          this.allData.sort((a, b)=>{
            return b['双低分数'] - a['双低分数']
          })
        },
        power: ()=>{
          this.allData.sort((a, b)=>{
            return b['强势分数'] - a['强势分数']
          })
        }
      }
      fn[this.type] && fn[this.type]()
      this.allData=this.allData.map((i, ind)=>{
        i.index=ind+1
        return i
      })
      this.rawData=[...this.allData]
    },

    // 排序
    sortChange({ column, prop, order }){
      // console.log(order)
      this.allData=this.allData.sort((a, b)=>{
        if (order==='ascending') {
          // 升序
          if (prop === '评级') return this.levels[a[prop]] - this.levels[b[prop]]
          return a[prop] - b[prop]
        } else {
          // 降序
          if (prop === '评级') return this.levels[b[prop]] - this.levels[a[prop]]
          return b[prop] - a[prop]
        }
      })
    },


    // 滚动
    scrollFn() {
      this.$nextTick(() => {
        const dom=document.querySelector('.el-table__body-wrapper')
        // 配置数量，有些屏幕比较高，无法自适应
        setTimeout(()=>{
          const height=dom.offsetHeight
          const size=Math.floor(height / 31)
          this.size=size > 30 && (size + 6) || 30
        })

        // 监听滚动
        dom.addEventListener('scroll', (e) => {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            const {
              target
            } = e
            const canScrollHeight = target.scrollHeight - target.offsetHeight
            // console.log(e, canScrollHeight, target.scrollTop)
            if (target.scrollTop > this.maxScrollTop) {
              this.maxScrollTop = target.scrollTop
              if (target.scrollTop / canScrollHeight >= 0.8) this.page++
            }

          }, 50);
        })
      })
    },

    // 筛选
    filterFn(params){
      this.filterParams=params
    },

    // 点击收藏
    async clickCollect(row){
      if (!row.isCollect) {
        await this.addBondCollect(row['转债代码'], row['转债价格'])
      } else {
        await this.cancalBondCollect(row['转债代码'])
      }
      this.getBondCollectList()
    },


    // 获取用户收藏列表
    async getBondCollectList(){
      if (!isLoginStatus()) return
      let res=await this.$api.getBondCollectList({
        page: 1,
        limit: 1000
      })
      if (res) {
        this.collectList=res.rows
      }
    },

    // 获取用户收藏列表
    async getBondList(){
      if (!isLoginStatus()) return
      this.$store.dispatch('getBondList')
    },

    // 用户取消转债收藏
    async addBondCollect(id, price){
      return new Promise(async (resolve, reject)=>{
        // const item=this.bondList.find(it=>it.bond_code==id)
        let res=await this.$api.addBondCollect({
          // bond_id: item && item.id || ''
          bond_code: id,
          bond_price: price
        })
        resolve()
      })
    },

    // 用户取消转债收藏
    async cancalBondCollect(id){
      return new Promise(async (resolve, reject)=>{
        // const item=this.bondList.find(it=>it.bond_code==id)
        let res=await this.$api.cancalBondCollect({
          // bond_id: item && item.id || ''
          bond_code: id
        })
        resolve()
      })
    },

    // 保存筛选
    savaFilter(){
      localStorage.setItem(`__${this.$route.name}_filterParams`, JSON.stringify(this.filterParams))
    },
    // 获取筛选参数
    getFilter(){
      const filterParams=localStorage.getItem(`__${this.$route.name}_filterParams`)
      filterParams && (this.filterParams=JSON.parse(filterParams))
    },


    // 申请数据成功
    buyDataSuccess(){
      this.getData()
    },


    // 自刷
    async autoRefreshFn(value){
      if (value) {
        // 开启
        await this.$store.dispatch('getBuyDataStatus')
        if (!this.isValidity) {
          this.$message.error('数据已过期')
          this.autoRefresh=false
          return
        }
        this.autoRefresh=true
        this.autoRefreshTimer=randomTimer({
          context: this,
          timerField: 'autoRefreshTimer',
          max: 5000,
          min: 3000,
          fn: ()=>this.getData({
            noMessage: {
              noLoading: 1
            }
          })
        })
      } else {
        // 关闭
        this.autoRefresh=false
        clearTimeout(this.autoRefreshTimer)
      }
    },


    // 打开实时行情
    openRealTimeQuotes({e, type, row}){
      e.preventDefault()
      if (type=='bond') {
        this.marketDialog.bondCode=row['转债代码']
        this.marketDialog.code=row['转债代码']
        this.marketDialog.title=`转债行情 ${row['债券简称']}`
      } else {
        this.marketDialog.bondCode=row['转债代码']
        this.marketDialog.code=row['正股代码']
        this.marketDialog.title=`正股行情 ${row['正股名称']}`
      }
      this.marketDialog.visible=true
    },

    // 下载数据
    async downloadFile(){
      this.$api.downloadFile().then(res=>{
        let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let objectUrl = URL.createObjectURL(blob)
        //创建a标签链接并点击 start
        let link = document.createElement('a')
        link.style.display = 'none';
        link.href = objectUrl
        link.download = `多因子数据.csv`
        document.body.appendChild(link);
        link.click();
        //创建a标签链接并点击 end
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blob)
      })
    },

    // 自动购买数据
    async autoBuyDataFn(value){
      localStorage.setItem('autoBuyData', value)
      
      if (isLoginStatus() && value && this.allData[0] && isNaN(parseFloat(this.allData[0]['综合分数']))) {
        await this.$api.buyData()
        this.getData({ noBuy: true })
      }
    },

    // 获取热门板块
    getHotPlates({
      allPlates, // 板块数据
      allData
    }){
      if (!allData || !allData[0] || isNaN(parseFloat(allData[0]['综合分数']))) return '-'
      // 板块
      const blackList = [
        "AH股",
        "HS300_",
        "标准普尔", 
        "富时罗素",
        "广东板块",
        "沪股通", 
        "机构重仓", 
        "融资融券",
        "上证180_",
        "转债标的", 
        "浙江板块", 
        "创投", 
        "创业板综", 
        "IPO受益", 
        "西藏板块", 
        "甘肃板块", 
        "雄安新区", 
        "江苏板块", 
        "深成500",
        "深股通", 
        "中证500", 
        "山东板块", 
        "基金重仓", 
        "送转预期",
        "预盈预增", 
        "湖南板块", 
        "宁夏板块", 
        "重庆板块", 
        "昨日连板",
        "昨日连板_含一字",
        "昨日涨停",
        "昨日涨停_含一字", 
        "江西板块", 
        "深圳特区", 
        "参股新三板",
        "分拆预期", 
        "湖北板块", 
        "QFII重仓", 
        "MSCI中国", 
        "北京板块",
        "证金持股", 
        "安徽板块", 
        "京津冀",
        "天津板块", 
        "海南板块", 
        "股权激励", 
        "上证380", 
        "山西板块",
        "中药概念",
        "医疗器械概念",
        "电商概念"
      ]
      let plates={}
      allPlates.filter(p=>!blackList.includes(p)).forEach(p=>plates[p]=0)
    
      // 各表前二十
      let data={
        multiFactor: allData.sort((a, b)=>b['综合分数'] - a['综合分数']).slice(0, 20),
        multiFactor_v1_1: allData.sort((a, b)=>b['多因子V1.1'] - a['多因子V1.1']).slice(0, 20),
        fiveFactor: allData.sort((a, b)=>b['五因子分数'] - a['五因子分数']).slice(0, 20),
        dbLow: allData.sort((a, b)=>b['双低分数'] - a['双低分数']).slice(0, 20),
        power: allData.sort((a, b)=>b['强势分数'] - a['强势分数']).slice(0, 20),
      }
      
      // 计算热门板块
      let cache=[...data['multiFactor'], ...data['multiFactor_v1_1'], ...data['fiveFactor'], ...data['dbLow'], ...data['power']]
      cache=cache.reduce((acc, cur)=>{
        if (acc.every(r=>r['转债代码']!=cur['转债代码'])) acc.push(cur)
        return acc
      }, [])
      cache.forEach(r=>{
        Object.keys(plates).forEach(k=>{
          if (r['所属版块'] && r['所属版块'].includes(k)) plates[k]++
        })
      })
      // console.log(plates, cache)
      // 返回热门板块
      return Object.keys(plates).sort((a, b)=>{
        return plates[b] - plates[a]
      }).slice(0, 6)
    },

    // 过滤出热门的数据
    setHotPlatesData(plateName){
      this.filterParams={
        '所属版块': [plateName],
        sort: 20
      }
    },


    // 保存自定义因子
    saveCustomFactor() {
      this.customFactorData.visible = false

      // this.saveCustomFactorWeights()
      if (this.customFactorData.id) {
        this.setStrategie(false)
      } else {
        this.setStrategie()
      }
      this.doDiyScore()
    },
    
    // 归一化
    async normalization() {
      // 只处理有权重的因子
      const data = this.customFactorData.data.filter(it => it.weight);
      if (!data.length) return;

      for (let factor of data){
        const prop = factor.prop;
        // 收集所有数据
        const arr = this.allData.map(row => parseFloat(row[prop]));
        // console.log(arr,"arr")
        // 归一化，直接传reverse参数
        // const normArr = robustNormalize(arr, null, factor.reverse);
        // const normArr = robustNormalize(arr, factor.reverse);
        let normArr = robustNormalize(arr);
        // let normArr=await this.getGuiyiData(arr)
        // console.log(normArr, "normArr")
        if (!factor.reverse) {
          normArr=normArr.map(i=>1-i)
        }
        // console.log(normArr,"normArr")
        // 写回allData
        this.allData.forEach((row, idx) => {
          row[`${prop}_guiyi`] = normArr[idx];
        });
      };
    },

    // 计算自定义分数
    setScore() {
      // 获取有权重的因子
      const data = this.customFactorData.data.filter(it => it.weight);
      if (!data.length) return;

      // 先算总权重
      const totalWeight = data.reduce((sum, factor) => sum + Number(factor.weight), 0);
      if (!totalWeight) return;

      this.allData.forEach(row => {
        let score = 0;
        data.forEach(factor => {
          const prop = factor.prop;
          const weight = parseFloat(factor.weight) || 0;
          const value = parseFloat(row[`${prop}_guiyi`]) || 0;
          // 每个属性的真正权重 = weight / totalWeight
          score += value * (weight / totalWeight);
        });
        row['自定义分数'] = score;
      });
      // console.log(this.allData)
    },

    // 计算分数并排序
    async doDiyScore(){
      if (this.customFactorData.data.every(it=>!it.weight)) {
        // 没有权重，重置自定义分数
        this.allData.forEach(row => row["自定义分数"]="-")
        return
      }
      // console.log(this.customFactorData.data, 999)
      await this.normalization()
      this.setScore()
      this.sortChange({ prop: "自定义分数", order: "descending" })
      this.allData=this.allData.map((i, ind)=>{
        i.index=ind+1
        return i
      })
      this.rawData=[...this.allData]
      this.$message.success(`${this.customFactorData.name} 计算成功`)
    },


    // 切换策略
    onStrategyChange(id) {
      const strategy = this.strategies.find(it=>it.id==id);
      if (!strategy) return;
      // console.log(this.selectedStrategy)
      // 策略名称直接覆盖
      this.customFactorData.id = strategy.id;
      this.customFactorData.name = strategy.name;
      // 权重和方向按prop一一对应覆盖
      this.customFactorData.data.forEach(it=>{
        const target = strategy.data.find(d => d.prop === it.prop);
        if (target) {
          // const rawItem = toRaw(it);
          it.weight = target.weight;
          it.reverse = Number(target.reverse);
        }
      })
    },


    // 确认
    addConfirm(){
      this.setStrategie()
    },
    // 取消
    addClear(){
      this.strategieName = ''
      this.isAdding = false
    },
    // 删除策略
    delStrategie(item){
      console.log(item)
    },

    // 获取多因子策略列表
    async getStrategieList(id) {
      // return
      if (this.$route.path!="/diy_table") return
      try {
        const res = await this.$api.getFactorList();
        // console.log(res, 11111)
        if (res) {
          // 格式化为本地strategies结构
          this.strategies = res.map(item => ({
            id: item.id,
            name: item.title,
            data: JSON.parse(item.weights) || []
          }));
          if (this.strategies.length) {
            this.selectedStrategy=Number(id) || this.strategies[0].id
            this.onStrategyChange(this.selectedStrategy)
          }
          console.log("strategies", this.strategies)
          console.log("customFactorData", this.customFactorData)
        }
      } catch (e) {
        // this.$message.error("获取策略列表失败");
      }
    },

    // 新增或更新多因子策略
    async setStrategie(isAdd=true) {
      // return
      if (isAdd && !this.strategieName && !this.customFactorData.name) {
        this.$message.error("请输入策略名称");
        return;
      }
      if (!isAdd && !this.customFactorData.name) {
        this.$message.error("请输入策略名称");
        return;
      }

      // 构造参数
      const params = {
        title: this.strategieName || this.customFactorData.name,
        content: "",
        // weights: JSON.stringify(this.customFactorData.data)
        weights: this.customFactorData.data
      };

      if (!isAdd) {
        params.id=this.customFactorData.id
        params.title=this.customFactorData.name
      }
      // console.log(999,params)
      try {
        const res=await this.$api.setFactorStrategie(params);
        if (res) {
          // this.$message.success("保存成功");
          this.isAdding = false;
          this.strategieName = "";
          // 刷新策略列表
          this.getStrategieList(res.id);
        }
      } catch (e) {
        // this.$message.error("保存失败");
      }
    },
    
    // 获取归一化数据
    async getGuiyiData(list){
      let res=await axios({
        url: "http://47.115.151.237:5001/normalize",
        method: "get",
        params:{
          values: list.join(",")
        }
      })
      // console.log(res.data.results)
      if (res.status==200) {
        return res.data.results.map(it=>it.normalized_value)
      }
    },

    // 处理右键菜单
    handleRowContextMenu(row, column, event) {
      event.preventDefault()
      this.contextMenu.visible = true
      this.contextMenu.x = event.clientX
      this.contextMenu.y = event.clientY
      this.contextMenu.row = row
      
      // 点击其他地方关闭菜单
      const closeMenu = () => {
        this.contextMenu.visible = false
        document.removeEventListener('click', closeMenu)
      }
      setTimeout(() => {
        document.addEventListener('click', closeMenu)
      }, 100)
    },

    // 分析标的
    analyzeTarget(type) {
      if (!this.contextMenu.row) return
      
      const row = this.contextMenu.row
      const symbol = type === 'bond' ? row['转债代码'] : row['正股代码']
      const name = type === 'bond' ? row['债券简称'] : row['正股名称']
      
      // 跳转到AI分析页面，使用params传递参数（只有效一次）
      this.$router.push({
        name: 'ai_analysis',
        params: {
          type,
          symbol,
          name
        }
      })
      
      this.contextMenu.visible = false
    }
  },
  created() {
    this.$store.dispatch('getAllPlates')
    this.getData()
    this.getBondCollectList()
    // this.getBondList()
    this.getFilter()
  },
  watch: {
    height(){
      this.scrollFn()
    },
    filterParams:{
      handler(){
        this.savaFilter()
      },
      deep: true
    }
  },

  beforeUnmount() {
    clearTimeout(this.autoRefreshTimer)
  },
  deactivated() {
    clearTimeout(this.autoRefreshTimer)
  },
  activated() {
    this.autoRefreshFn(this.autoRefresh)
  }
})